class PhoneNumberMask {
    addMaskToElementId(elementId, addValidation = false)
    {
        const elm = document.getElementById(elementId);

        if(elm){
            this._addListenerAndApplyMaks(elm);

            if(addValidation){
                this.addFormatValidation(elm);
            }
        }
    }

    addMaskToClass(className, addValidation = false)
    {
        const elements = document.getElementsByClassName(className);

        if(elements.length){
            for(let i = 0; i < elements.length; i++){
                this._addListenerAndApplyMaks(elements[i]);

                if(addValidation){
                    this.addFormatValidation(elements[i]);
                }
            }
        }
    }

    addMaskToSelector(selector, addValidation = false){
        const elements = document.querySelectorAll(selector);

        if(elements.length){
            for(let i = 0; i < elements.length; i++){
                this._addListenerAndApplyMaks(elements[i]);

                if(addValidation){
                    this.addFormatValidation(elements[i]);
                }
            }
        }
    }

    _addListenerAndApplyMaks(elm)
    {
        const that = this;
        elm.addEventListener('input', function (e) {
            const val = e.target.value;
            e.target.value = that._maskInput(val);
        });

        elm.value = this._maskInput(elm.value);
    }

    /**
     * From: https://stackoverflow.com/a/29335409
     * @param value
     * @returns {*|string}
     * @private
     */
    _maskInput(value)
    {
        var x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    }

    addFormatValidation(input){
        input.addEventListener('input', () => {
            input.setCustomValidity('');
            input.checkValidity();
        });

        input.addEventListener('invalid', () => {
            if(input.value === '') {
                input.setCustomValidity('Please enter your phone number.');
            } else {
                input.setCustomValidity('Enter phone number in this format: (123) 456-7890');
            }
        });
    }
}

export {PhoneNumberMask};